<template>
  <div
    :style="`display: ${settings.display};top: ${settings.top}px; left: ${settings.left}px`"
    class="map-popup"
  >
    <ul class="map-popup__list">
      <li
        v-for="item in settings.values"
        :key="item.key"
        class="map-popup__item"
      >
        <div class="map-popup__key">
          {{ item.key }}
        </div>
        <div class="map-popup__value">
          {{ getValue(item.value) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    getValue(value) {
      return value === 0 ? value : value || 'Не указано'
    }
  }
}
</script>

<style lang="scss">
.map-popup {
  position: absolute;
  border-radius: var(--border-radius);
  border: 1px solid transparent;
  background-color: var(--bg_surface) !important;
  border-color: var(--dividers_low_contrast) !important;
  color: var(--text_primary) !important;
  min-width: 120px;
  padding: 8px;
  font-size: 12px;
  z-index: 10;

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:not(:first-child) {
      margin-top: 4px;
    }
  }

  &__key {
    margin-right: 16px;
  }
  &__value {
    font-weight: bold;
  }
}
</style>
